<template>
  <v-card
    id="glance"
    :width="imageSize"
    class="mt-4 mr-4"
  >
    <v-img
      contain
      :src="getImage()"
      :height="imageSize"
    />

    <v-card-subtitle>
      {{ getGlancedOptionsItem.name }}
    </v-card-subtitle>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'GlanceOptionsItem',

    computed: {
      ...mapGetters(['getGlancedOptionsItem']),
      imageSize () {
        if (this.$vuetify.breakpoint.smAndDown) return 150
        return 200
      },
    },

    methods: {
      getImage () {
        let image = require('@/assets/placeholder.png')
        if (this.getGlancedOptionsItem.image) image = this.getGlancedOptionsItem.image
        return image
      },
    },
  }
</script>

<style scoped>
#glance {
  top: 0;
  right: 0;
  position: absolute;
}

</style>
